import React from 'react'

import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export const columns = [
  {
    title: "OECD 5 Reporting Guidelines ",
    dataIndex: 'name',
    key: 'name',
    colSpan: 1,
  },
  {
    title: "Supply Chain Report",
    dataIndex: 'completion',
    className: 'text-center',
    key: 'completion',
    colSpan: 1,
  },
  {
    title: "Disclosure Policy Summary",
    dataIndex: 'policy',
    key: 'policy',
    className: 'text-center',
    colSpan: 1,
    render: value => {
      if (typeof value === 'boolean') {
        return <CheckOutlined style={{ color: "#23af52" }} />
      }
      return <span>
        <span style={{ color: 'red' }}>{value.split('/')[0]}</span>/{value.split('/')[1]}
      </span>
    }
  },
  {
    title: "Public Due Diligence Report",
    dataIndex: 'report',
    className: 'text-center',
    key: 'report',
    colSpan: 1,
    render: value => {
      if (typeof value === 'boolean') {
        return <CheckOutlined style={{ color: "#23af52" }} />
      }
      return <span>
        <span style={{ color: 'red' }}>{value.split('/')[0]}</span>/{value.split('/')[1]}
      </span>
    }
  },
  {
    title: 'Actions',
    key: 'actions',
    colSpan: 1,
    render: () => <Button size="small" type="primary">Details</Button>
  }
];

export const data = [
  {
    key: '1',
    name: 'In-Country Supply Chain Participants',
    completion: 'CADD',
    policy: '2/7',
    report: '2/7',
  },
  {
    key: '2',
    name: 'Exporter',
    completion: 'CADD',
    policy: true,
    report: true,
  },
  {
    key: '3',
    name: 'Intermediary',
    completion: 'CADD',
    policy: true,
    report: true,
  },
  {
    key: '4',
    name: 'Internation Trading SA',
    completion: 'CADD',
    policy: true,
    report: true,
  },
];

const all = {
  columns,
  data,
}
export default all;
